export const AppRoutes = {
  home: "/",
  onboarding: "/onboarding",
  login: "/login",
  logout: "/logout",
  about: "/about",
  planning: "/planning",
  checklist: "/checklist",
  criticalGapRequirementApproval: "/checklist/requirements-approval",
  value: "/value",
  imoSummary: "/imo-summary",
  steerCo: "/steer-co",
  settings: "/settings",
  settingsDealDetails: "/settings/deal-details",
  settingsUserSettings: "/settings/user-settings",
  settingsUserAccess: "/settings/user-access",
  settingsProjectDocuments: "/settings/project-documents",
  settingsValidateMappings: "/settings/validate-mappings",
  settingsAdditionalDocuments: "/settings/project-documents",
  settingsPrompts: "/settings/prompts",
  settingsAiFeedback: "/settings/ai-feedback",
  settingsAiInsightsTest: "/settings/ai-insights-test",
  settingsAiInsightsDev: "/settings/ai-insights-dev",
  settingsAiTraces: "/settings/ai-traces",
  settingsAiTraceDetail: "/settings/ai-traces/:traceId",
  settingsPromptDetail: "/settings/prompts/:promptId/:versionId",
  settingsTemplateDetail: "/settings/prompts/templates/:templateId/:versionId",
  integrationPlanning: "/integration-planning",
  integrationPlanningDetails: "/integration-planning/:id",
  raid: "/raid",
  decisionsLog: "/decisions-log",
  aiChat: "/ai-chat",
  examples: "/examples",
  notFound: "*",
  forbidden: "/403",
} as const;

export function getIntegrationPlanningDetailsRoute(id: string) {
  return AppRoutes.integrationPlanningDetails.replace(":id", encodeURIComponent(id));
}

export function getSettingsPromptDetailRoute(promptId: string | number, versionId: string | number) {
  return AppRoutes.settingsPromptDetail
    .replace(":promptId", String(promptId))
    .replace(":versionId", String(versionId));
}

export function getSettingsTemplateDetailRoute(templateId: string | number, versionId: string | number) {
  return AppRoutes.settingsTemplateDetail
    .replace(":templateId", String(templateId))
    .replace(":versionId", String(versionId));
}
